import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';
import { ContentService } from '../../services/content/content.service';
import { HelperService } from '../../services/helper/helper.service';

@Pipe({
  name: 'contentRestaurant'
})
export class RestaurantPipe implements PipeTransform {

  constructor(private contentService: ContentService) {
  }

  private static removeLeadingBr(string = ''): string {
    while (string.trim()?.startsWith('<br>') || string.trim()?.startsWith('<br/>') || string.trim()?.startsWith('<br />')) {
      if (string.trim()?.startsWith('<br>')) {
        string = string.replace('<br>', '');
      } else if (string.trim()?.startsWith('<br/>')) {
        string = string.replace('<br/>', '');
      } else if (string.trim()?.startsWith('<br />')) {
        string = string.replace('<br />', '');
      }
    }
    return string;
  }

  private static enhanceRestaurantDetail(restaurantContent, data) {
    restaurantContent.subtitle = data.subtitle;
    restaurantContent.teaser = RestaurantPipe.removeLeadingBr(data.introduction || data.description);
    restaurantContent.description = RestaurantPipe.removeLeadingBr(data.description);
    if (data?.openingHours?.regularOpeningHours) {
      let useOpeningHours = false;
      if (data.openingHours.exceptionDays && data.openingHours.exceptionDays.length) {
        useOpeningHours = true;
      }
      for (const key of Object.keys(data.openingHours.regularOpeningHours)) {
        if (data.openingHours.regularOpeningHours[key].open) {
          useOpeningHours = true;
        }
      }
      if (useOpeningHours) {
        restaurantContent.openingHours = data.openingHours;
      }
    }
    restaurantContent.openingHours = HelperService.initOpeningData(data) || data.openingHours;
    if (!!data?.openingHours?.disabled) {
      delete restaurantContent.openingHours;
    }
    restaurantContent.seasonTimes = data.seasonTimes;
    restaurantContent.website = data.website;
    restaurantContent.categories = data.categories;
    if (data.location) {
      restaurantContent.street = data.location.address;
      restaurantContent.city = data.location.city;
      restaurantContent.zip = data.location.zip;
      if (data.location.coordinates) {
        restaurantContent.latitude = data.location.coordinates.latitude;
        restaurantContent.longitude = data.location.coordinates.longitude;
      }
    }
    if (data.bookable && data.bookingUrl) {
      restaurantContent.bookable = data.bookable;
      restaurantContent.bookingUrl = data.bookingUrl;
      restaurantContent.bookingText = data.bookingTextScreen || data.bookingText;
    }
    if (data.contact && data.contact.length) {
      for (const contactVariant of data.contact[0].variants) {
        if (contactVariant.type === 'phone') {
          restaurantContent.phone = contactVariant.value;
        }
        if (contactVariant.type === 'fax') {
          restaurantContent.fax = contactVariant.value;
        }
        if (contactVariant.type === 'email') {
          restaurantContent.email = contactVariant.value;
        }
      }
    }

    return HelperService.setEmptyStringsToNull(restaurantContent)
  }

  transform(entry: Models.ContentEntry): Models.RestaurantEntry | Models.RestaurantEntry[] {
    if (!entry) {
      return null;
    }
    /* restaurant master */
    if (entry.related && entry.related.entries && entry.related.entries.length > 0) {
      let sortBySortField = false;
      const entries: Models.RestaurantEntry[] = [];

      let contentEntries = [];
      for (const item of entry.related.entries) {
        if (!this.contentService.getEntry(item.id)) {
          continue;
        }
        const contentEntry = this.contentService.getEntry(item.id);
        try {
          const raw = JSON.parse(contentEntry.detail.raw);
          if (raw.order !== null && raw.order !== undefined) {
            contentEntry.detail['order'] = raw.order;
            sortBySortField = true;
          }
        } catch (err) {}
        contentEntries.push(contentEntry);
      }
      if (sortBySortField) {
        contentEntries = _.orderBy(contentEntries, ['detail.order', 'title'], ['asc', 'asc']);
      }

      for (const item of contentEntries) {
        const relatedEntry = this.transform(item) as Models.RestaurantEntry;
        if (relatedEntry) {
          entries.push(relatedEntry);
        }
      }
      return entries.length ? entries : null;
    }

    /* detail */
    if (!entry || !entry.title) {
      return null;
    }
    const restaurant = new Models.RestaurantEntry();

    let media = this.contentService.getMediaEntriesForEntry(entry?.getId?.() || entry?._id);
    const documents = this.contentService.getDocumentEntriesForEntry(entry?.getId?.() || entry?._id);

    media = _.orderBy(media, ['type'], ['asc']);

    let restaurantContent = { sourceId: entry._id, title: entry.title.trim(), media, documents };

    if (entry.detail) {
      restaurantContent = RestaurantPipe.enhanceRestaurantDetail(restaurantContent, entry.detail);
    }

    restaurant.populateFromJSON(restaurantContent);
    return restaurant;
  }
}
